import { Workbook, Worksheet } from "exceljs";

/**
 *
 * @param {Worksheet} sheet
 * @param {number} indexLength
 * @returns {Worksheet}
 */
export function sheetStyling(sheet, indexLength) {
  for (let o = 1; o <= indexLength; o++) {
    sheet.getColumn(o).width = 20;
  }
  const firstRow = sheet.getRow(1);
  firstRow.alignment = { horizontal: "center", vertical: "middle" };
  firstRow.font = { bold: true, name: "Arial Black", size: 12 };

  sheet.eachRow({ includeEmpty: true }, (row, _) => {
    row.height = 20;
    if (row.number != 1) row.font = { name: "Arial" };
    for (let o = 1; o <= indexLength; o++) {
      const cell = row.getCell(o);
      if (cell.row == "1") {
        cell.fill = {
          type: "pattern",
          pattern: "darkVertical",
          fgColor: { argb: "CDCDCD" },
          bgColor: { argb: "CDCDCD" },
        };
      }
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    }
  });
  return sheet;
}

/**
 *
 * @param {{[x:string]:string}[]} sheets
 * @param {string[]} sheetNames
 * @returns
 */
function arrayDataToWBJs(sheets, sheetNames) {
  const wb = new Workbook();
  wb.creator = "Hair and Hands";

  for (let i = 0; i < sheets.length; i++) {
    let worksheet = wb.addWorksheet(sheetNames[i] || "Page " + i);

    let indexes;
    if (sheets[i].length > 0) {
      indexes = Object.getOwnPropertyNames(sheets[i][0]);

      worksheet.addRow(indexes);
      for (let o = 1; o <= indexes.length; o++) {
        worksheet.getColumn(o).width = 20;
      }

      for (const value of sheets[i]) {
        worksheet.addRow(Object.values(value));
      }
      worksheet = sheetStyling(worksheet, indexes.length);
    }
  }

  return wb;
}

/**
 *
 * @param {{[x:string]:string}[]} data
 * @param {string[]} sheetNames
 * @returns {Workbook}
 */
export function jsonToExcelJs(data, sheetNames) {
  try {
    let wb = new Workbook();
    if (data.sccrSem25) wb = arrayDataToWBJs(data.sccrSem25, data.names);
    else wb = arrayDataToWBJs(data, sheetNames);
    return wb;
  } catch (error) {
    throw new Error("Ocurrió un error al generar el archivo.");
  }
}
/**
 *
 * @param {any} targetObj
 * @param {string} keyPath
 * @returns {string}
 */
function getPropertyByKeyPath(targetObj, keyPath) {
  let keys = keyPath.split(".");
  if (keys.length == 0) return undefined;
  keys = keys.reverse();
  let subObject = targetObj;

  while (keys.length) {
    const k = keys.pop();
    if (!subObject.hasOwnProperty(k)) return undefined;
    else subObject = subObject[k];
  }
  return subObject;
}

/**
 *
 * @param {any} entity
 * @param {{name: string;defaultValue?: any;props: {inValue: string;outValue: string;defaultValue?: any}[]}} prop
 * @param {number} index
 */
function mapJson(entity, prop, index) {
  const obj = {};
  for (const { inValue, outValue, defaultValue } of prop.props) {
    if (typeof defaultValue === "function") {
      obj[outValue] = defaultValue(entity, index);
    } else if (typeof prop.defaultValue === "function") {
      obj[outValue] = prop.defaultValue(entity);
    } else {
      obj[outValue] =
        getPropertyByKeyPath(entity, inValue) ||
        defaultValue ||
        prop.defaultValue;
    }
  }

  return obj;
}

/**
 *
 * @param {any[][]} arr
 * @param {{name: string;defaultValue?: any;props: {inValue: string;outValue: string;defaultValue?: any}[]}[]} props
 */
export function jsonToJson(arr, props) {
  const json = [];
  for (let i = 0; i < arr.length; i++) {
    json.push(arr[i].map((x, index) => mapJson(x, props[i], index)));
  }
  return { sccrSem25: json, names: props.map((x) => x.name) };
}

/**
 *
 * @param {Workbook} workbook
 */
export const workbookToBlob = async (workbook) => {
  const buffer = await workbook.xlsx.writeBuffer();
  return new Blob([Uint8Array.from(buffer).buffer]);
};



// WEBPACK FOOTER //
// ./src/common/helpers/excel.js